"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.addExMobile = addExMobile;
exports.allotSelectUsers = allotSelectUsers;
exports.cancelPlanMeasure = cancelPlanMeasure;
exports.changeUser = changeUser;
exports.completeCust = completeCust;
exports.custToFollowUser = custToFollowUser;
exports.declassifyCust = declassifyCust;
exports.default = void 0;
exports.del = del;
exports.distributorAdd = distributorAdd;
exports.downloadCustList = downloadCustList;
exports.edit = edit;
exports.editBaseInfo = editBaseInfo;
exports.getIndexTitle = getIndexTitle;
exports.isExist = isExist;
exports.isExistAddress = isExistAddress;
exports.isExistWechat = isExistWechat;
exports.rejectCust = rejectCust;
exports.testRedis = testRedis;
exports.transCust = transCust;

var _request = _interopRequireDefault(require("@/utils/request"));

function add(data) {
  return (0, _request.default)({
    url: 'api/cust/addCust',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/cust/',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/cust',
    method: 'put',
    data: data
  });
}

function editBaseInfo(data) {
  return (0, _request.default)({
    url: 'api/cust/editBaseInfo',
    method: 'put',
    data: data
  });
}

function changeUser(data) {
  return (0, _request.default)({
    url: 'api/cust/changeUser',
    method: 'post',
    data: data
  });
}

function allotSelectUsers(data) {
  return (0, _request.default)({
    url: 'api/cust/allotSelectUsers',
    method: 'post',
    data: data
  });
}

function transCust(data) {
  return (0, _request.default)({
    url: 'api/cust/transCust',
    method: 'post',
    data: data
  });
}

function custToFollowUser(data) {
  return (0, _request.default)({
    url: 'api/cust/custToFollowUser',
    method: 'post',
    data: data
  });
}

function isExistAddress(data) {
  return (0, _request.default)({
    url: 'api/cust/isExistAddress?address=' + data.address,
    method: 'get',
    data: data
  });
}

function addExMobile(data) {
  return (0, _request.default)({
    url: 'api/cust/addExMobile',
    method: 'post',
    data: data
  });
}

function isExist(data) {
  return (0, _request.default)({
    url: 'api/cust/isExist?mobile=' + data.mobile,
    method: 'get',
    data: data
  });
}

function isExistWechat(data) {
  return (0, _request.default)({
    url: 'api/cust/isExistWechat?custWechat=' + data.custWechat,
    method: 'get',
    data: data
  });
}

function rejectCust(data) {
  return (0, _request.default)({
    url: 'api/cust/rejectCust',
    method: 'put',
    data: data
  });
}

function testRedis(data) {
  return (0, _request.default)({
    url: 'api/dog/getAllDogName',
    method: 'get',
    data: data
  });
}

function completeCust(data) {
  return (0, _request.default)({
    url: 'api/cust/completeCust',
    method: 'put',
    data: data
  });
}

function declassifyCust(data) {
  return (0, _request.default)({
    url: 'api/cust/declassifyCust',
    method: 'put',
    data: data
  });
}

function cancelPlanMeasure(data) {
  return (0, _request.default)({
    url: 'api/cust/cancelPlanMeasure',
    method: 'put',
    data: data
  });
}

function distributorAdd(data) {
  return (0, _request.default)({
    url: 'api/cust/distributorAdd',
    method: 'post',
    data: data
  });
}

function getIndexTitle() {
  return (0, _request.default)({
    url: 'api/cust/getIndexTitle',
    method: 'get'
  });
}

function downloadCustList(params) {
  return (0, _request.default)({
    url: 'api/cust/downloadCustList',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}

var _default = {
  distributorAdd: distributorAdd,
  cancelPlanMeasure: cancelPlanMeasure,
  declassifyCust: declassifyCust,
  completeCust: completeCust,
  add: add,
  edit: edit,
  del: del,
  testRedis: testRedis,
  changeUser: changeUser,
  isExistAddress: isExistAddress,
  isExist: isExist,
  isExistWechat: isExistWechat,
  addExMobile: addExMobile,
  allotSelectUsers: allotSelectUsers,
  editBaseInfo: editBaseInfo,
  transCust: transCust,
  custToFollowUser: custToFollowUser,
  rejectCust: rejectCust,
  getIndexTitle: getIndexTitle,
  downloadCustList: downloadCustList
};
exports.default = _default;